// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppointmentsCron_cronOptionContainer__tirJv {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.AppointmentsCron_cronOption__vJvk- {
  display: flex;
  flex-wrap: wrap;
  row-gap: 5px;
  align-items: center;
}

.AppointmentsCron_cronOptionRadioButton__m57vh {
  margin-right: 10px;
}

.AppointmentsCron_cronOptionPortion__Nccxj {
  margin-right: 10px;
}

.AppointmentsCron_periodTypeDropDown__5E0Bl {
  margin-bottom: 10px;
}

.AppointmentsCron_weeklyContainer__zigSU {
  display: flex;
  flex-wrap: wrap;
}

.AppointmentsCron_weeklyOption__2iLqT {
  width: 124px;
}

.AppointmentsCron_numberOptionDropDown__yfEQp {
  width: 81px;
}

.AppointmentsCron_nDayOfWeekOptionDropDown__VVBVm {
  width: 116px;
}

.AppointmentsCron_dayOfWeekOptionDropDown__gFhu3 {
  width: 146px;
}

/* mobile */
@media (max-width: 550px) {
  .AppointmentsCron_cronOptionContainer__tirJv {
    gap: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/appointments/AppointmentsCron.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,WAAW;AACX;EACE;IACE,SAAS;EACX;AACF","sourcesContent":[".cronOptionContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.cronOption {\n  display: flex;\n  flex-wrap: wrap;\n  row-gap: 5px;\n  align-items: center;\n}\n\n.cronOptionRadioButton {\n  margin-right: 10px;\n}\n\n.cronOptionPortion {\n  margin-right: 10px;\n}\n\n.periodTypeDropDown {\n  margin-bottom: 10px;\n}\n\n.weeklyContainer {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.weeklyOption {\n  width: 124px;\n}\n\n.numberOptionDropDown {\n  width: 81px;\n}\n\n.nDayOfWeekOptionDropDown {\n  width: 116px;\n}\n\n.dayOfWeekOptionDropDown {\n  width: 146px;\n}\n\n/* mobile */\n@media (max-width: 550px) {\n  .cronOptionContainer {\n    gap: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cronOptionContainer": `AppointmentsCron_cronOptionContainer__tirJv`,
	"cronOption": `AppointmentsCron_cronOption__vJvk-`,
	"cronOptionRadioButton": `AppointmentsCron_cronOptionRadioButton__m57vh`,
	"cronOptionPortion": `AppointmentsCron_cronOptionPortion__Nccxj`,
	"periodTypeDropDown": `AppointmentsCron_periodTypeDropDown__5E0Bl`,
	"weeklyContainer": `AppointmentsCron_weeklyContainer__zigSU`,
	"weeklyOption": `AppointmentsCron_weeklyOption__2iLqT`,
	"numberOptionDropDown": `AppointmentsCron_numberOptionDropDown__yfEQp`,
	"nDayOfWeekOptionDropDown": `AppointmentsCron_nDayOfWeekOptionDropDown__VVBVm`,
	"dayOfWeekOptionDropDown": `AppointmentsCron_dayOfWeekOptionDropDown__gFhu3`
};
export default ___CSS_LOADER_EXPORT___;
